import './_mini-cart-progress.scss';
import component from './mini-cart-progress';

export default component;
